import { QuickReturnsActions } from "../../types";

export function append(items: [any], tags: [any]): any {
  tags.forEach((tag) => {
    tag.item = items.find((item) => item?.number === tag.item_number) || {
      number: tag.item_number,
      description: "",
    };
  });

  return { type: QuickReturnsActions.AssetAppend, assets: tags };
}

export function remove(item: any) {
  return { type: QuickReturnsActions.AssetRemove, item };
}
